import { NavController, NavParams, App, ModalController, ViewController, ToastController } from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { Component, OnInit, Input } from '@angular/core';

import { AuthProvider } from '../../../../providers/auth/auth';
import { EmployeeRhProvider } from '../../../../providers/employeerh/employeerh';
import { ProfilePage } from '../../profile/profile';
import { MessagePage } from '../../message/message';


@Component({
  selector: 'page-rh-skillsearch',
  templateUrl: 'rh-skillsearch.html',
})
export class RhSkillSearchPage implements OnInit {

  skills:any = null;
  skillsList:any = null;
  results:any = null;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public storageProvider: Storage,
    public app: App,
    public authProvider: AuthProvider,
    public employeeRhProvider: EmployeeRhProvider,
    public viewCtrl: ViewController,
    public toastCtrl: ToastController
  ) { }

  currUserId: string = this.authProvider.user.user_id;


  ngOnInit() {
        this.loadDatas();
  }

  loadDatas() {
    this.employeeRhProvider.listCustomSkills().subscribe((res) => {
      if(res.success){
        this.skills = res.data;
      }
    })
  }

  searchChange(e){
    this.employeeRhProvider.searchCustomSkillUsers(this.skillsList).subscribe((res) => {
      if(res.success){
        this.results = res.data;
        console.log(res.data)
      }
    })
  }
   
  dismiss() {
      this.viewCtrl.dismiss();
  }

  goToProfile(user) {
    let contact = [
      user.id,
      user.first_name,
      user.last_name,
      user.position,
      ''
    ]
    this.navCtrl.push(MessagePage, {recipient: contact})
    .then(() => {
      console.log('Welcome to Message');
    })
  }

  // Decoding image buffer
  ab2str(arraybuffer) {
    return new TextDecoder("utf-8").decode(new Uint8Array(arraybuffer))
  }


}



// WEBPACK FOOTER //
// ./src/pages/employee/_rh/rh-skillsearch/rh-skillsearch.ts